import React, { useContext } from "react";
import MarkDown from 'react-markdown';
import accounting from 'accounting';
import type { MembershipTypeSaleInfoModel } from '../../../tsrestapi/models';
import { BecomeMemberButtons } from "../../organisms/memberships";
import TranslatorManager from 'ts-translate-js';
import { SiteCustomizationContext } from "../../../logic/reactcontext/site-customization-context";

const tr = TranslatorManager.boundTR;

type MembershipCardPubProps = {
    membershipType: MembershipTypeSaleInfoModel;
    onNewMembershipCardClick: (membershipType: MembershipTypeSaleInfoModel) => void;
    onAlreadyMembershipCardClick: (membershipType: MembershipTypeSaleInfoModel) => void;
    showBecomeMemberButtons?: boolean;
    showMoreInfosLink?: boolean;
};

export function MembershipCardPub({ 
    membershipType, onNewMembershipCardClick, onAlreadyMembershipCardClick, showBecomeMemberButtons = true, showMoreInfosLink = false
}: MembershipCardPubProps) {
    const {siteSettings} = useContext(SiteCustomizationContext);

    return <li key={membershipType.id}>
        <div className='membership-card-pub'>
            <div className='card-info-lightbulb'>
                <i className="far fa-lightbulb"></i>
            </div>
            <div>
                <MarkDown
                    className="markdown-inline"
                    source={tsapp.tr("ticketpriceselection.yoursaving", { amount: accounting.formatMoney(siteSettings.taxesOnlyAtCheckout ? membershipType.savingAmountBeforeTaxes : membershipType.savingAmount) })}
                /> 
                <br />
                {
                    //TODO: Refactor this as a button
                    //eslint-disable-next-line sonarjs/anchor-is-valid
                    !showMoreInfosLink ? <a href="#" onClick={() => onNewMembershipCardClick(membershipType)}>
                        <strong>{membershipType.name}</strong>
                    </a> : <strong>{membershipType.name}</strong> 
                }
            </div>
        </div>
        {showMoreInfosLink && <div>
            {/* TODO: Refactor this as a button*/}
            {/* eslint-disable-next-line sonarjs/anchor-is-valid */}
            <a href="#" onClick={() => onNewMembershipCardClick(membershipType)}>
                {tr("Voir plus d'informations")}
            </a>
        </div>}
        {showBecomeMemberButtons && <BecomeMemberButtons 
            membershipType={membershipType}
            onAlreadyMemberClick={onAlreadyMembershipCardClick}
            onBecomeMemberClick={onNewMembershipCardClick}
        />}
    </li>;
}